/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Navigate, RouteObject, useRoutes } from "react-router-dom";

import CELink from "../../pages/CELink";
import Login from "../../pages/Login";
import { isPlatformMobile } from "../../util/platform";
import { HOME_ROUTE } from "../../util/routing";

const UnauthenticatedRoutes = () => {
  const routes: RouteObject[] = [
    {
      path: process.env.REACT_APP_AZURE_CE_B2C_LINK_URI,
      element: isPlatformMobile() ? <Navigate to={HOME_ROUTE} /> : <CELink />,
    },
    { path: "*", element: <Login key="Login-Screen" /> },
  ];

  return useRoutes(routes);
};

export default UnauthenticatedRoutes;
